import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import useLanguageConfigurator from "./hooks/useLanguageConfigurator";
import { RouterView } from "components/router/RouterView";
import useAuth from "features/auth/useAuth";
import { useDispatch } from "app/store";
import FullPageSpin from "components/FullPageSpin";
import useConfigurationQuery from "hooks/queries/useConfigurationQuery";
import Claims from "features/auth/claims";

function App() {
  const { antDLocale } = useLanguageConfigurator();
  const { userInfo } = useAuth();
  const dispatch = useDispatch();
  const configurationQuery = useConfigurationQuery();
  const view = localStorage.getItem("fortana-view");
  const { hasClaim } = useAuth();

  useEffect(() => {
    if (
      (hasClaim([Claims.View.Tablet]) && !hasClaim([Claims.View.Desktop])) ||
      (view === "tablet" &&
        hasClaim([Claims.View.Desktop]) &&
        hasClaim([Claims.View.Tablet]))
    ) {
      dispatch.common.setDeviceLayoutType("mobile");
    } else {
      dispatch.common.setDeviceLayoutType("default");
    }
  }, [dispatch.common, userInfo, view, hasClaim]);

  return configurationQuery.isSuccess ? (
    <ConfigProvider locale={antDLocale}>
      <RouterView />
    </ConfigProvider>
  ) : (
    <FullPageSpin />
  );
}

export default App;
